<script setup lang="ts">
import axios from 'axios'
import i18n from '@/plugins/i18n'
import { useAppStore } from '@/stores/app'
import { useAuthStore } from '@/stores/auth'
import { useOrganisationSaveSettings } from '@/composable/queries/Dara/organisation'

const appStore = useAppStore()
const authStore = useAuthStore()

const saveSettings = useOrganisationSaveSettings()

const confirming = ref(false)

const setAsDefault = (() => {
  if (authStore.organisation?.id) {
    confirming.value = true

    const data = {
      default_locale: authStore.organisation?.default_locale,
      is_duplex_printing_enabled: authStore.organisation?.is_duplex_printing_enabled,
      myhq_version: 'new',
      notification_low_licence: authStore.organisation?.notification_settings.low_licences,
      report_name: authStore.organisation?.report_name,
      timezone: authStore.organisation?.timezone,
      year_sub_group_known_as: authStore.organisation?.year_sub_group_known_as,
    }

    saveSettings.mutate(data,
      { onSuccess: () => {
        confirming.value = false
        appStore.showPreviewBarModal = false
        appStore.setSnackbar({
          colour: 'success',
          text: 'The new MyHQ has been set as your default version.',
        })
      },
      onError: error => {
          interface ErrorResponse {
            errors: {
              [key: string]: string[]
            }
            message: string
          }
          if(
            axios.isAxiosError(error)
            && error.response
            && error.response
            && error.response.status === 422
          ) {
            const responseData = error.response.data as ErrorResponse

            appStore.setSnackbar({
              colour: 'error',
              text: responseData.message,
            })
          }

          confirming.value = false
      } })
  }
})
</script>

<template>
  <VDialog
    v-model="appStore.showPreviewBarModal"
    width="auto"
    max-width="35rem"
  >
    <VCard>
      <VCardTitle>
        Set Default MyHQ Version
      </VCardTitle>
      <VCardText>
        Click the 'Confirm' button to set the new MyHQ as your default version.
      </VCardText>
      <VCardActions class="d-flex justify-space-between ma-2">
        <VBtn
          color="grey"
          variant="outlined"
          class="text-none"
          :disabled="confirming"
          @click="appStore.showPreviewBarModal = false"
        >
          {{ i18n.global.t('actions.cancel') }}
        </VBtn>
        <VBtn
          color="secondary"
          variant="flat"
          class="text-none"
          :loading="confirming"
          @click="setAsDefault"
        >
          {{ i18n.global.t('actions.confirm') }}
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>
